import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { breakpoints, Spacings, Fonts } from '@styles/index';
import Carousel from '@comp/Carousel/Carousel';
import { useIsMobile } from '@stores/AppCommonData';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const Container = styled.div`
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    margin-bottom: ${Spacings.SPACING_2B};
  }
`;

const Item = styled.div`
  width: 272px;
  cursor: pointer;
  text-align: left;
  border-radius: ${Spacings.SPACING_2B};
  color: ${({ $isSelected }) =>
    $isSelected ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'};
  background-color: ${({ $isSelected }) =>
    $isSelected ? 'var(--color-base-1)' : 'var(--color-divider)'};
  box-shadow: ${boxShadowGenerator()};
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B} ${Spacings.SPACING_5B};
  margin-bottom: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.SEMIBOLD};
  transition: background-color 300ms ease-out, color 300ms ease-out;

  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

const CombatCardNavigation = ({ currentIndex, items, onItemClick }) => {
  const isMobile = useIsMobile();
  const handleItemClick = (index) => () => {
    onItemClick(index);
  };

  const renderItems = () =>
    items.map(({ uid, label }, index) => (
      <Item
        key={uid}
        gridColumn="span 4 / auto"
        $isSelected={currentIndex === index}
        onClick={handleItemClick(index)}
      >
        {label}
      </Item>
    ));

  return (
    <Container>
      {isMobile ? (
        <Carousel
          showInfo={false}
          showBottomGap={false}
          key="combat_nav_items"
          numberOfItems={2}
        >
          {renderItems()}
        </Carousel>
      ) : (
        renderItems()
      )}
    </Container>
  );
};

CombatCardNavigation.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onItemClick: PropTypes.func.isRequired
};

export default CombatCardNavigation;
